/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

export type AppWeatherModelType = typeof AppWeatherModelType[keyof typeof AppWeatherModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppWeatherModelType = {
  barra: 'barra',
  barpa: 'barpa',
  bom_reanalysis: 'bom_reanalysis',
  barra2: 'barra2',
  forecast: 'forecast',
} as const;
